import { useState } from "react";
import editIcon from "../../assets/images/common/lab-edit.svg";
import deleteIcon from "../../assets/images/common/lab-delete.svg";
import Tick from "./Tick";
import Cross from "./Cross";
import AcceptModal from "./AcceptModal";
import CancelModal from "./CancelModal";
import CustomPagination from "./CustomPagination";
import "../../assets/css/common/common.scss";

const LaboratoryWrapper = ({ title, requestSectionTitle, rows, icon }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [showTickModal, setShowTickModal] = useState(false);
  const [showCrossModal, setShowCrossModal] = useState(false);

  const testAppointments = [
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
    {
      name: "Calvin Carlo",
      department: "Haematology",
      date: "12 Dec 2022",
    },
  ];

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const totalRows = rows.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const startIndex = page * rowsPerPage;
  const endIndex = Math.min(startIndex + rowsPerPage, totalRows);
  const visibleRows = rows.slice(startIndex, endIndex);

  //  AcceptAppointModal handler
  const handleTickClick = () => {
    console.log("hey");
    setShowTickModal(true);
  };

  //  CancelAppointentModal handlar
  const handleCrossClick = () => {
    setShowCrossModal(true);
  };
  return (
    <>
      <AcceptModal
        heading="Accept Request"
        description="Are you sure you want accept the test panel request?"
        open={showTickModal}
        onClose={() => setShowTickModal(false)}
      />
      <CancelModal
        heading="Cancel Request"
        description="Are you sure you want to cancel the test panel request?"
        open={showCrossModal}
        onClose={() => setShowCrossModal(false)}
      />

      <div class="wrapper">
        <div class="row  m-0 first-row">
          <div class="col-lg-8 ">
            <div class="left-div">
              <div className="details-wrapper">
                <div className="heading">{title}</div>

                <div className="details-card-wrapper">
                  {visibleRows?.map((test,index) => {
                    return (
                      <div className="detail-card">
                        <div className="card-header-detail">
                          <img src={icon} />
                          <div className="detail">
                            <div className="name">{test.testname}</div>
                            {test?.testdepartment ? (
                              <div className="department">
                                {test?.testdepartment}
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                        <div className="card-body">
                          <div className="rate">{test.rate}</div>
                          <div className="edit-delete">
                            <img src={editIcon} />
                            <img src={deleteIcon} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="pagination-container">
                <div className="pagination-detail">
                  Showing {page * rowsPerPage + 1} -{" "}
                  {Math.min((page + 1) * rowsPerPage, rows.length)} of{" "}
                  {rows.length}
                </div>
                <CustomPagination
                  page={page}
                  totalPages={totalPages}
                  onChangePage={handleChangePage}
                />
              </div>
            </div>
          </div>

          <div class="col-lg-4 ">
            <div class="right-div">
              <div className="container-wrapper">
                <div className="header">
                  <div className="title">{requestSectionTitle}</div>
                  <hr
                    style={{
                      borderColor: "border: 1px solid #E4E3E4 !important",
                      margin: "0px",
                    }}
                  />
                </div>
                <div className="list-wrapper">
                  {testAppointments.map((appointment) => {
                    return (
                      <>
                        <div className="list">
                          <div className="detail">
                            <div className="name">Calvin Carlo</div>
                            <div className="department">Haematology</div>
                            <div className="date">12 Dec 2022</div>
                          </div>
                          <div className="permissions">
                            <Tick onTick={handleTickClick} />
                            <Cross onCross={handleCrossClick} />
                          </div>
                        </div>
                        <hr style={{ margin: "0px" }} />
                      </>
                    );
                  })}
                </div>
                {/* <button className="">All Doctors</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LaboratoryWrapper;
